import { createAction } from 'redux-act';
import { toastr } from 'react-redux-toastr';
import { url } from 'utils/url';
import { errorMsg, refreshToken } from 'utils';
import axios from 'axios';

export const WEB_CONTENTS_FETCH = createAction('WEB_CONTENTS_FETCH');
export const WEB_CONTENTS_FETCH_DATA_SUCCESS = createAction('WEB_CONTENTS_FETCH_DATA_SUCCESS');
export const WEB_CONTENTS_FETCH_DATA_FAIL = createAction('WEB_CONTENTS_FETCH_DATA_FAIL');

export const WEB_CONTENTS_DELETE_INIT = createAction('WEB_CONTENTS_DELETE_INIT');
export const WEB_CONTENTS_DELETE_SUCCESS = createAction('WEB_CONTENTS_DELETE_SUCCESS');
export const WEB_CONTENTS_DELETE_FAIL = createAction('WEB_CONTENTS_DELETE_FAIL');

export const WEB_CONTENTS_CREATE_INIT = createAction('WEB_CONTENTS_CREATE_INIT');
export const WEB_CONTENTS_CREATE_SUCCESS = createAction('WEB_CONTENTS_CREATE_SUCCESS');
export const WEB_CONTENTS_CREATE_FAIL = createAction('WEB_CONTENTS_CREATE_FAIL');

export const WEB_CONTENTS_MODIFY_INIT = createAction('WEB_CONTENTS_MODIFY_INIT');
export const WEB_CONTENTS_MODIFY_SUCCESS = createAction('WEB_CONTENTS_MODIFY_SUCCESS');
export const WEB_CONTENTS_MODIFY_FAIL = createAction('WEB_CONTENTS_MODIFY_FAIL');

export const WEB_CONTENTS_CLEAN_UP = createAction('WEB_CONTENTS_CLEAN_UP');
export const WEB_CONTENTS_CLEAR_DATA_LOGOUT = createAction('WEB_CONTENTS_CLEAR_DATA_LOGOUT');

export const fetchWebContents = ({ siteId }) => async (dispatch) => {
  dispatch(WEB_CONTENTS_FETCH());
  try {
    const token = await refreshToken();
    const res = await axios.get(`${url}/webContents/list/${siteId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return dispatch(WEB_CONTENTS_FETCH_DATA_SUCCESS({ list: res.data.data || [] }));
  } catch (error) {
    toastr.error('', `${errorMsg(dispatch, error)}`);
    return dispatch(WEB_CONTENTS_FETCH_DATA_FAIL({ error }));
  }
};

export const addWebContents = (data, callback) => async (dispatch) => {
  dispatch(WEB_CONTENTS_CREATE_INIT());
  try {
    const token = await refreshToken();
    const res = await axios.post(`${url}/webContents/create`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    toastr.success('', 'Post created successfully');
    dispatch(WEB_CONTENTS_CREATE_SUCCESS({ content: res.data.data }));
    if (callback) callback();
  } catch (error) {
    toastr.error('', `${errorMsg(dispatch, error)}`);
    return dispatch(WEB_CONTENTS_CREATE_FAIL({ error }));
  }
};

export const updateWebContents = (id, data, callback) => async (dispatch) => {
  dispatch(WEB_CONTENTS_MODIFY_INIT());
  try {
    const token = await refreshToken();
    const res = await axios.put(`${url}/webContents/${id}`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    toastr.success('', 'Post updated successfully');
    dispatch(WEB_CONTENTS_MODIFY_SUCCESS({ content: res.data.data, id }));
    if (callback) callback();
  } catch (error) {
    toastr.error('', `${errorMsg(dispatch, error)}`);
    return dispatch(WEB_CONTENTS_MODIFY_FAIL({ error }));
  }
};

export const deleteWebContents = ({ id, siteId }, callback) => async (dispatch) => {
  dispatch(WEB_CONTENTS_DELETE_INIT());
  try {
    const token = await refreshToken();
    await axios.delete(`${url}/webContents/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    toastr.success('', 'Post deleted successfully');
    dispatch(WEB_CONTENTS_DELETE_SUCCESS({ id }));
    if (callback) callback();
  } catch (error) {
    toastr.error('', `${errorMsg(dispatch, error)}`);
    return dispatch(WEB_CONTENTS_DELETE_FAIL({ error }));
  }
};
